import { useWriteContract, useWaitForTransactionReceipt } from 'wagmi';
import { soulContract } from '../../contracts/contracts';
export const useMintSoulSpToken = () => {
  const { writeContract, data: hash, isPending } = useWriteContract();
  const { isLoading, isSuccess: isConfirmed } = useWaitForTransactionReceipt({hash});
  const handleMint = async () => {
    await writeContract({
      ...soulContract,
      functionName: 'mint',
    });
  }
  console.log(isLoading, 'isLoading');
  console.log(isConfirmed, 'isConfirmed');
  
  return {
    handleMint,
    hash,
    isConfirmed,
  }
}